import { Component, EventEmitter, Output, OnInit, Input } from "@angular/core";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import * as moment from "moment";
import { environment } from "../../../environments/environment";
import { RegistrationData } from "../../widget.model";

@Component({
  selector: "register-form",
  templateUrl: "./register-form.component.html",
  styleUrls: ["./register-form.component.scss"],
})
export class RegisterFormComponent implements OnInit {
  @Input() errorPatientExist: boolean;
  @Input() selectedLanguageIsoCode: string;

  bsConfig: Partial<BsDatepickerConfig>;
  selectedDate: Date;
  showEmailError: boolean = false;
  showFieldsError: boolean = false;

  registrationData = {} as RegistrationData;

  @Output() sendRegistrationData = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.bsConfig = Object.assign({}, { showWeekNumbers: false });
  }

  onSubmit(form) {
    let formIsValid = form.form.status === "VALID";
    let mailIsValid = form.value.email === form.value.repeatEmail;
    let fieldsAreValid =
      form.value.telNumber !== "" &&
      form.value.email !== "" &&
      form.value.firstName !== "" &&
      form.value.lastName !== "" &&
      form.value.repeatEmail !== "";
    if (formIsValid && mailIsValid) {
      this.registrationData = {
        ...this.registrationData,
        firstName: form.value.firstName,
        lastName: form.value.lastName,
        birthDate: moment(form.value.birthDate).format("YYYY-MM-DD"),
        email: form.value.email,
      };
      this.sendRegistrationData.next(this.registrationData);
      this.showEmailError = false;
      this.showFieldsError = false;
    }
    if (!mailIsValid && fieldsAreValid) {
      this.showEmailError = true;
      this.showFieldsError = false;
    }
    if (!fieldsAreValid) {
      this.showEmailError = false;
      this.showFieldsError = true;
    }
  }

  onValueChange(date: Date) {
    this.selectedDate = date;
  }

  handleMobilePhoneChange(value: string) {
    if (!value) return;
    this.registrationData.telNumber = value;
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/components/register-form/register-form.component.ts